module.exports = __webpack_public_path__ + "img/economy-energySavings.47cf7bd9.svg";